/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const FastForwardCircleIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Fast Forward Circle',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M18 2a16 16 0 1 0 16 16A16 16 0 0 0 18 2Zm-8 23.017V10.984a1 1 0 0 1 1.625-.781L14 12.1v11.8l-2.375 1.9A1 1 0 0 1 10 25.017Zm18.4-6.236L19.625 25.8A1 1 0 0 1 18 25.017V10.984a1 1 0 0 1 1.625-.781L28.4 17.22a1 1 0 0 1 0 1.561Z"
    />
  </svg>`;
};
